import { SKILL_TITLES } from "@tutor/curriculum/titles";
import type { Locale } from "@tutor/protocol";

// Human-readable names for skill ids, from the curriculum's generated titles (titles only:
// no items or answers reach the app). An id the catalogue lacks gets a tidy fallback.

export function skillLabel(skillId: string, locale: Locale): string {
  return SKILL_TITLES[skillId]?.[locale] ?? prettifySkillId(skillId);
}

/** `math.fractions.compare-unlike` → `Fractions: compare unlike`. */
export function prettifySkillId(skillId: string): string {
  const words = skillId
    .split(".")
    .filter((part) => part !== "")
    .map((part) => part.replace(/[-_]+/g, " ").trim());
  // The first segment is the subject; it adds little to a child-facing label.
  const meaningful = words.length > 1 ? words.slice(1) : words;
  const [head = skillId, ...rest] = meaningful;
  const capitalised = head.charAt(0).toLocaleUpperCase() + head.slice(1);
  return rest.length === 0 ? capitalised : `${capitalised}: ${rest.join(", ")}`;
}
